import { render } from "./pdp-geo-messaging.vue?vue&type=template&id=ac0b05aa"
import script from "./pdp-geo-messaging.vue?vue&type=script&lang=js"
export * from "./pdp-geo-messaging.vue?vue&type=script&lang=js"

import "./pdp-geo-messaging.vue?vue&type=style&index=0&id=ac0b05aa&lang=scss"

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__